import { INIT_CONTENT } from '../constants/types';

export const initContent = content => {
  return {
    type: INIT_CONTENT,
    content,
  };
};

export default initContent;
